import { useApiClient } from '../useApi/useApiClient';
import { IRegistrationRequest, IRegistrationResponse } from '@/hooks/api/useRegisterion/useRegistration.interfaces';

export const useRegistration = () => {
    const { fetch, loading } = useApiClient<IRegistrationResponse>();

    const register = async (request: IRegistrationRequest) =>
        await fetch({
            url: '/register',
            method: 'POST',
            body: request,
        });

    return {
        register,
        loading,
    };
};
